import React from "react";
import PropTypes from "prop-types";
import { merge } from "lodash";

// Stylesheets
import "./SleepHeroSection.scss";

// Components
import { ImgixImage, ImgixPicture, ImgixSource } from "../Utils/ImgixImage";

const DEFAULT_IMAGE_DIMENSIONS = {
  mobile: { width: 400, height: 560 },
  tablet: { width: 800, height: 420 },
  desktop: { width: 1200, height: 650 },
};

export const SleepLandingPageHeroSection = ({
  header,
  image,
  imageDimensions,
  imgixProps,
  altText,
}) => {
  const dimensions = merge(DEFAULT_IMAGE_DIMENSIONS, imageDimensions);
  const { mobile, tablet, desktop } = dimensions;

  return (
    <section className="sleep_hero_section section full_width_section">
      {header}
      <ImgixPicture
        fallback={
          <ImgixImage
            src={image.src}
            imgixProps={imgixProps.mobile}
            height={mobile.height}
            width={mobile.width}
            isShopify
            className="hero_image"
            sizes={{ default: "100vw" }}
            alt={altText || image.altText || "Dream Shop"}
          />
        }
      >
        <ImgixSource
          src={image.src}
          imgixProps={imgixProps.desktop}
          height={desktop.height}
          width={desktop.width}
          isShopify
          htmlAttributes={{ media: "(min-width: 1024px)" }}
        />
        <ImgixSource
          src={image.src}
          imgixProps={imgixProps.tablet}
          height={tablet.height}
          width={tablet.width}
          isShopify
          htmlAttributes={{ media: "(min-width: 768px)" }}
        />
      </ImgixPicture>
    </section>
  );
};

SleepLandingPageHeroSection.propTypes = {
  header: PropTypes.element.isRequired,
  image: PropTypes.object.isRequired,
  imageDimensions: PropTypes.shape({
    mobile: PropTypes.object,
    tablet: PropTypes.object,
    desktop: PropTypes.object,
  }),
  imgixProps: PropTypes.shape({
    mobile: PropTypes.object,
    tablet: PropTypes.object,
    desktop: PropTypes.object,
  }),
  altText: PropTypes.string,
};

SleepLandingPageHeroSection.defaultProps = {
  imgixProps: {},
};

export default SleepLandingPageHeroSection;
